/*
 * Flayvr Ami — Shopify-native controls patch v28.2.0
 *
 * Scope:
 * - No visual styles are added or changed.
 * - Hides only the generated Continue button used by Ami multi-select questions.
 * - The existing composer arrow advances the selected multi-select answer.
 * - Enter advances the selected multi-select answer.
 * - Typed answers continue to use the approved v27.7 engine unchanged.
 */
(function () {
  'use strict';

  var VERSION = '28.2.0';
  var ROOT_SELECTOR = '[data-flayvr-ami-v27]';
  var CHOICE_BOX_SELECTOR = '.flami-choices';
  var CONTINUE_SELECTOR = '.flami-choice[data-next]';
  var SELECTED_SELECTOR = '.flami-choice.is-selected';

  function toArray(value) {
    return Array.prototype.slice.call(value || []);
  }

  function visibleChoiceBoxes(root) {
    return toArray(root.querySelectorAll(CHOICE_BOX_SELECTOR)).filter(function (box) {
      return !box.closest('[hidden]');
    });
  }

  function hideContinueButton(button) {
    if (!button) return;
    if (!button.hidden) button.hidden = true;
    if (button.getAttribute('aria-hidden') !== 'true') button.setAttribute('aria-hidden', 'true');
    if (button.getAttribute('tabindex') !== '-1') button.setAttribute('tabindex', '-1');
    if (button.dataset.amiContinueHidden !== VERSION) button.dataset.amiContinueHidden = VERSION;
  }

  function hideGeneratedContinueButtons(root) {
    toArray(root.querySelectorAll(CONTINUE_SELECTOR)).forEach(hideContinueButton);
  }

  function activeMultiContinue(root) {
    var boxes = visibleChoiceBoxes(root);

    for (var index = boxes.length - 1; index >= 0; index -= 1) {
      var box = boxes[index];
      var next = box.querySelector(CONTINUE_SELECTOR);
      if (!next) continue;

      hideContinueButton(next);

      if (next.disabled) return null;
      if (!box.querySelector(SELECTED_SELECTOR)) return null;
      return next;
    }

    return null;
  }

  function syncComposerState(root) {
    hideGeneratedContinueButtons(root);

    var input = root.querySelector('[data-ami-input]');
    var send = root.querySelector('[data-ami-send]');
    if (!input || !send) return;

    var hasTypedText = String(input.value || '').trim().length > 0;
    var canContinue = Boolean(activeMultiContinue(root));

    root.dataset.amiNativeControls = VERSION;
    root.dataset.amiArrowCanContinue = canContinue ? 'true' : 'false';

    if (!hasTypedText && canContinue) {
      send.removeAttribute('disabled');
      send.setAttribute('aria-label', 'Continue');
    } else if (!hasTypedText) {
      send.setAttribute('aria-label', 'Send to Ami');
    }
  }

  function advanceSelectedChoices(root, event) {
    var input = root.querySelector('[data-ami-input]');
    if (!input || String(input.value || '').trim()) return false;

    var next = activeMultiContinue(root);
    if (!next) return false;

    if (event) {
      event.preventDefault();
      event.stopPropagation();
      if (typeof event.stopImmediatePropagation === 'function') {
        event.stopImmediatePropagation();
      }
    }

    next.click();
    window.requestAnimationFrame(function () {
      syncComposerState(root);
    });
    return true;
  }

  function installRoot(root) {
    if (!root || root.dataset.amiNativeControlsInstalled === VERSION) return;
    root.dataset.amiNativeControlsInstalled = VERSION;

    var chat = root.querySelector('[data-ami-chat]');
    var input = root.querySelector('[data-ami-input]');
    var send = root.querySelector('[data-ami-send]');
    if (!chat || !input || !send) return;

    send.addEventListener('click', function (event) {
      advanceSelectedChoices(root, event);
    }, true);

    input.addEventListener('keydown', function (event) {
      if (event.key !== 'Enter' || event.shiftKey || event.isComposing) return;
      advanceSelectedChoices(root, event);
    }, true);

    input.addEventListener('input', function () {
      syncComposerState(root);
    });

    chat.addEventListener('click', function () {
      window.requestAnimationFrame(function () {
        syncComposerState(root);
      });
    });

    var observer = new MutationObserver(function () {
      syncComposerState(root);
    });

    observer.observe(chat, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class', 'disabled', 'hidden']
    });

    root._flayvrAmiNativeControlsObserver = observer;
    syncComposerState(root);
  }

  function installAll(scope) {
    var context = scope && scope.querySelectorAll ? scope : document;
    toArray(context.querySelectorAll(ROOT_SELECTOR)).forEach(installRoot);
  }

  function boot() {
    installAll(document);

    document.addEventListener('shopify:section:load', function (event) {
      installAll(event.target || document);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }

  window.FlayvrAmiNativeControls = {
    version: VERSION,
    installAll: installAll,
    diagnostics: function () {
      return toArray(document.querySelectorAll(ROOT_SELECTOR)).map(function (root) {
        return {
          rootId: root.id || '',
          installed: root.dataset.amiNativeControlsInstalled === VERSION,
          continueButtons: root.querySelectorAll(CONTINUE_SELECTOR).length,
          visibleContinueButtons: toArray(root.querySelectorAll(CONTINUE_SELECTOR)).filter(function (button) {
            return !button.hidden;
          }).length,
          arrowCanContinue: root.dataset.amiArrowCanContinue === 'true'
        };
      });
    }
  };
})();
